const angular = require('angular');

const { expressAddressPanelControllerComponentDefinition } = require('./express-address-panel.component');
const { expressCartItemCountControllerComponentDefinition } = require('./express-cart-item-count.component');

angular.module('wowApp.shop')
    .component('wowExpressAddressPanel', expressAddressPanelControllerComponentDefinition)
    .component('wowExpressCartItemCount', expressCartItemCountControllerComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/express/index.js